// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gp-3";
export var downloadButton = "_gp-4";
export var fileContainer = "_gp-9 _gp-7";
export var fileContainerBase = "_gp-7";
export var fileContainerFixedHeight = "_gp-8 _gp-7";
export var fileInfo = "_gp-5";
export var fileInfoWidthRestricted = "_gp-6";
export var fileType = "_gp-1";
export var fileTypeName = "_gp-2";
export var image = "_gp-0";
export var link = "_gp-b";
export var overflowEllipsis = "_gp-a";